import pusher from '../pusher'
import { permissionSettingsMapper } from '../mappers/permission-settings-mapper'

export function listenFormComponentEvents (event) {
  event.on('submitted', (formData) => {
    const mappedData = permissionSettingsMapper(formData)
    pusher.pushDataObject(mappedData)
  })
}
